<div class="ext-news">
    <tsv-news *ngFor="let news of news$ | async" [news]="news" [size]="'sm'"></tsv-news>
    <button class="ext-news-btn" [routerLink]="'/registrieren'" mat-raised-button>Registrieren für alle Neuigkeiten</button>
</div>